import ClearIcon from '@mui/icons-material/Clear';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import { DateField } from '@mui/x-date-pickers-pro';
import SDatePicker from 'components/SDatePicker';
import PropTypes from 'prop-types';
import React from 'react';
import { isMobile } from 'react-device-detect';
import useStyles from './styles';

function CustomToolbar(props) {
  const { classes } = useStyles();
  const { startDate, endDate, handleInputChange, handleInputFocus, handleInputClear, keyboardButtonProps, errors } =
    props;

  return (
    <>
      {isMobile && (
        <div className={classes.datesContainer}>
          <DateField
            size='small'
            id='start'
            value={startDate}
            inputFormat='LLL d, yyyy'
            label='Start date'
            // disableOpenPicker
            onChange={(value) => handleInputChange('start', value)}
            error={!!errors?.startHelperText}
            helperText={errors?.startHelperText}
          />
          <DateField
            size='small'
            id='end'
            value={endDate}
            inputFormat='LLL d, yyyy'
            label='End date'
            // disableOpenPicker
            onChange={(value) => handleInputChange('end', value)}
            error={!!errors?.endHelperText}
            helperText={errors?.endHelperText}
          />
        </div>
      )}

      {!isMobile && (
        <div className={classes.datesContainer}>
          <SDatePicker
            size='small'
            id='start'
            value={startDate}
            inputFormat='LLL d, yyyy'
            onChange={(value) => handleInputChange('start', value)}
            label={'Start date'}
            textFieldProps={{
              onFocus: handleInputFocus,
              InputProps: {
                endAdornment: (
                  <InputAdornment position='end'>
                    <IconButton
                      id={'clear-start-date'}
                      aria-label='clear start date'
                      onClick={() => handleInputClear('start')}
                      {...keyboardButtonProps}
                    >
                      <ClearIcon fontSize={'inherit'} />
                    </IconButton>
                  </InputAdornment>
                ),
              },
            }}
            disableOpenPicker
            error={!!errors?.startHelperText}
            helperText={errors?.startHelperText}
          />
          <SDatePicker
            size='small'
            id='end'
            value={endDate}
            inputFormat='LLL d, yyyy'
            onChange={(value) => handleInputChange('end', value)}
            label={'End date'}
            textFieldProps={{
              onFocus: handleInputFocus,
              InputProps: {
                endAdornment: (
                  <InputAdornment position='end'>
                    <IconButton
                      id={'clear-end-date'}
                      aria-label='clear end date'
                      onClick={() => handleInputClear('end')}
                      {...keyboardButtonProps}
                    >
                      <ClearIcon fontSize={'inherit'} />
                    </IconButton>
                  </InputAdornment>
                ),
              },
            }}
            disableOpenPicker
            error={!!errors?.endHelperText}
            helperText={errors?.endHelperText}
          />
        </div>
      )}
    </>
  );
}

CustomToolbar.propTypes = {
  startDate: PropTypes.object,
  endDate: PropTypes.object,
  handleInputChange: PropTypes.func.isRequired,
  handleInputFocus: PropTypes.func.isRequired,
  handleInputClear: PropTypes.func.isRequired,
  keyboardButtonProps: PropTypes.object.isRequired,
  errors: PropTypes.object,
};

export default CustomToolbar;
